<div class="h-full flex flex-col gap-4 overflow-x-hidden">
  @if (searchResults$ | async; as searchResults) {
    @if (searchResults.results.ranges.length === 0 && searchResults.results.machines.length === 0) {
      <div class="text-center text-muted">{{ 'searchResults.noResults' | transloco }}</div>
    } @else {
      @if (searchResults.results.ranges.length) {
        <div>
          <span class="inline-block text-muted mb-2">{{ 'searchResults.machineRanges' | transloco}}</span>
          <ul>
            @for (range of searchResults.results.ranges; track range.id) {
              <li>
                <a [routerLink]="['/machine-range', range.id]" class="block h-full w-full break-words pt-1 pb-1" (click)="handleRangeClick(range)">{{ range.title }}</a>
              </li>
            }
          </ul>
        </div>
      }

      @if (searchResults.results.machines.length) {
        <div>
          <span class="inline-block text-muted mb-2">{{ 'searchResults.machines' | transloco }}</span>

          <div class="flex flex-col gap-2">
            @for (machine of searchResults.results.machines; track machine.id) {
              <a [routerLink]="['/machine', machine.id]" class="flex items-center gap-3 min-w-0" (click)="handleMachineClick(machine)">
                <img ngSrc="/assets/images/placeholder.webp" width="80" height="64" alt="">
                <div class="flex flex-col min-w-0">
                  <span class="font-bold break-words">{{ machine.title }}</span>
                  <span class="break-words">{{ machine.desc }}</span>
                </div>
              </a>
            }
          </div>
        </div>
      }
    }
  }
</div>
